module.exports = __webpack_public_path__ + "img/c6.3551c7f0.png";